import { FC, useRef, useState, useCallback, useEffect } from 'react';

import FileSvg from 'assets/icons/file.svg';
import LoaderComponent from 'components/common/LoaderComponent';

interface FileProps {
  label?: string;
  headText?: string;
  name?: string;
  setFieldValue?: any;
  value?: string;
  error?: string;
}

const FileInput: FC<FileProps> = ({
  label,
  headText,
  name,
  setFieldValue,
  value,
  error,
}) => {
  const fileInput = useRef<any>(null);
  function openImageFile() {
    if (fileInput.current && !value) fileInput.current.click();
  }

  const [newerror, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (error) {
      setError(error);
    }
  }, [error]);

  const uploadImageToCloudinary = async (image: any) => {
    setError('');
    setLoading(true);
    const data = new FormData();
    data.append('file', image);
    data.append('upload_preset', 'septagon');
    const currentDate = new Date();
    data.append('api_key', '955177252593857');
    data.append('timestamp', '1315060510');

    let result: any = '';
    await fetch('https://api.cloudinary.com/v1_1/septagon/upload', {
      method: 'post',
      body: data,
    })
      .then((response) => response.json())
      .then((res) => {
        result = res;
      })
      .catch((err) => {
        setError('Unable to upload file');
      })
      .then(() => {
        setLoading(false);
      });

    return result;
  };

  const handleFileChange = async (e: any) => {
    const file = e.target.files[0];
    if (file.size > 1024000) {
      setError('File size cannot exceed more than 100MB');
    } else {
      const uploadedFile = await uploadImageToCloudinary(file);
      const newFile: any = {};
      newFile.url = uploadedFile.secure_url;
      newFile.name = file.name;
      setFieldValue(name, uploadedFile.secure_url);
    }
  };

  function isImgLink(url: any) {
    if (typeof url !== 'string') return false;
    return (
      url.match(/^http[^]*.(jpg|jpeg|gif|png|tiff|bmp)(\?(.*))?$/gim) != null
    );
  }

  const ShowImage = useCallback(({ image }: any) => {
    if (image.url && isImgLink(image.url)) {
      return (
        <div className="w-20 h-20">
          <img className="w-20 h-20" src={image.url} alt={image.name} />{' '}
        </div>
      );
    }
    return <p className="text-white">{image.name}</p>;
  }, []);

  return (
    <>
      {loading && <LoaderComponent />}
      <div className="">
        {label && (
          <label className="text-white text-lg mb-2" htmlFor={name}>
            {label}
          </label>
        )}
        {headText && (
          <p className="text-white opacity-75 text-xs my-4">{headText}</p>
        )}

        <div
          onClick={openImageFile}
          role="button"
          onKeyDown={openImageFile}
          aria-hidden="true"
          className={` ${
            error ? 'border-red-500' : 'border-primary-2'
          } flex flex-col align-center text-center border rounded-xl p-12`}
        >
          {value ? (
            <>
              <div className="text-center w-20 h-20">
                <img className="w-20 h-20" src={value} alt={name} />{' '}
              </div>
            </>
          ) : (
            <>
              <div className="flex justify-center">
                <img className="" src={FileSvg} alt="" />
              </div>
              <p className="text-white opacity-75">
                Drag and Drop a file to upload or{' '}
                <strong className="opacity-100">click here to upload</strong>{' '}
              </p>
            </>
          )}
        </div>
        {newerror && <p className="text-red-700 text-xs my-4">{newerror}</p>}

        <input
          type="file"
          onChange={(e) => {
            handleFileChange(e);
          }}
          name={name}
          ref={fileInput}
          style={{ display: 'none' }}
        />
      </div>
    </>
  );
};

export default FileInput;
